export default "January 28, 2020";